import styled from 'styled-components';
import Dropdown from './dropdown';
import LanguageDropdown from './language_dropdown';
import LanguageButton from './language_button';
import trackInMatomoAndGA from 'Shared/Analytics/CombinedGAMatomo';

const LanguageDropdownWrapper = styled(LanguageDropdown)`
   a:hover {
      text-decoration: none;
   }
`;

const LanguageDropdownContainer = ({
   languages,
   translationPreferencesUrl,
   machineTranslationRequested,
}: {
   languages: any[];
   translationPreferencesUrl: string;
   machineTranslationRequested: boolean;
}) => {
   const selectedLanguage = languages.find((language: any) => language.isSelected);
   const onMount = () => {
      trackInMatomoAndGA({
         eventCategory: 'Language',
         eventAction: 'Language Dropdown - Click',
      });
   };

   return (
      <Dropdown icon={<LanguageButton isoCode={selectedLanguage.isoCode} />} onMount={onMount}>
         <LanguageDropdownWrapper
            translationPreferencesUrl={translationPreferencesUrl}
            machineTranslationEnabled={true}
            machineTranslationRequested={machineTranslationRequested}
            languages={languages}
            isLightTheme={true}
         />
      </Dropdown>
   );
};

export default LanguageDropdownContainer;
